import { dataArrowDownSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowDownSolid = /*#__PURE__*/createIcon(dataArrowDownSolid)
export default IconArrowDownSolid
